export default __webpack_public_path__ + "static/media/trailer.4f0c5b32.mp4";